var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      ref: "roleList",
      attrs: { "element-loading-text": "查询中..." }
    },
    _vm._l(_vm.comList, function(com) {
      return com.comRoles != null && com.comRoles.length > 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "content-caption dashed",
                staticStyle: { margin: "10px 0" }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "color-laber" }),
                  _vm._v(_vm._s(com.name))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "switch-list clearfix ml10" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.checkedRoles,
                      callback: function($$v) {
                        _vm.checkedRoles = $$v
                      },
                      expression: "checkedRoles"
                    }
                  },
                  _vm._l(com.comRoles, function(role) {
                    return _c("el-checkbox", { attrs: { label: role.id } }, [
                      _c("span", [
                        _c("i", {
                          staticClass: "icon iconfont icon-wujiaoxingman mr5",
                          staticStyle: { color: "#eaea0f" }
                        }),
                        _vm._v(_vm._s(role.name))
                      ])
                    ])
                  })
                )
              ],
              1
            )
          ])
        : _vm._e()
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f0258fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f0258fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/RoleList.vue
// module id = 3475
// module chunks = 0